import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute'

import IntegrationFormLayout from './containers/Form'
import IntegrationsGridLayout from './containers/Grid'

export default function IntegrationLayout() {
  return <Router>
    <PrivateRoute exact path={["/settings/integrations", "/settings/integrations/unsubscribe", "/settings/integrations/sweep/finished", "/settings/integrations/sweep/:id/finished"]} component={IntegrationsGridLayout} />
    <PrivateRoute exact path={["/settings/integrations/add", "/settings/integrations/:id"]} component={IntegrationFormLayout} />
  </Router>
}
